.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* --------------------------------------------------------------- header */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
  margin-bottom: var(--space-5);
}

.headerText { min-width: 0; }

.title {
  font-size: var(--text-2xl);
  font-weight: var(--weight-semibold);
  line-height: 1.2;
}

.description {
  margin-top: var(--space-1);
  color: var(--text-muted);
  font-size: var(--text-base);
  max-width: 70ch;   /* long lines are hard to scan */
  line-height: var(--leading-normal);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-shrink: 0;
}

/* ----------------------------------------------------------------- card */
.card {
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.cardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--border);
}

.cardTitle {
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
}

.cardDescription {
  margin-top: var(--space-1);
  font-size: var(--text-sm);
  color: var(--text-muted);
  line-height: var(--leading-normal);
  max-width: 70ch;
}

.cardActions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}

.cardBody {
  padding: var(--space-5);
}

/* ------------------------------------------------------------- callout */
.callout {
  padding: var(--space-4);
  border-radius: var(--radius);
  border: 1px solid;
  border-left-width: 3px;
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.calloutTitle {
  font-weight: var(--weight-semibold);
  margin-bottom: var(--space-1);
}

.calloutBody p + p { margin-top: var(--space-2); }

.info {
  background: var(--info-soft);
  border-color: var(--info);
  color: var(--text);
}
.warning {
  background: var(--warning-soft);
  border-color: var(--warning);
  color: var(--text);
}
.danger {
  background: var(--danger-soft);
  border-color: var(--danger);
  color: var(--text);
}
.success {
  background: var(--success-soft);
  border-color: var(--success);
  color: var(--text);
}

/* ------------------------------------------------------------- toolbar */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  flex-wrap: wrap;
  margin-bottom: var(--space-4);
}
